import React from 'react';
import { ProgressProps } from 'antd';
import * as S from './styles';

export default function ProgressBar(props: Readonly<ProgressProps>): JSX.Element {
	return <S.ProgressWrapper {...props} />;
}
